import { ReactNode } from 'react';
import styles from './CustomerSectionWrapper.module.css';

type SectionWrapperProps = {
  children: ReactNode,
  title: string,
}

function CustomerSectionWrapper(props: SectionWrapperProps) {
  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <div className={styles.sectionName}>{props.title}</div>
      </div>
      {props.children}
    </div>
  );
}

export default CustomerSectionWrapper;
